import { Maximize2 } from 'lucide-react'
import type { ReactNode } from 'react'

import { Button } from '@/components/ui/clickable/Button'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/Dialog'

// Portaled to the body, so the copy inside never sits under the inline
// chart's data-chart-id and report exports can't pick it up.
export function ExpandedChartDialog({
  title,
  toolbar,
  children,
}: {
  title?: string | null
  toolbar?: ReactNode
  children: ReactNode
}) {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button
          type="button"
          theme="ghost"
          size="xs"
          className="gap-1.5 text-muted-foreground"
        >
          <Maximize2 className="size-3.5" aria-hidden />
          Expand
        </Button>
      </DialogTrigger>
      <DialogContent
        aria-describedby={undefined}
        className="flex max-h-[calc(100vh-4rem)] w-[calc(100vw-4rem)] max-w-none flex-col bg-card"
      >
        <DialogHeader className="gap-3 pr-10">
          <DialogTitle className="text-pretty text-blue-7">
            {title || 'Chart'}
          </DialogTitle>
          {toolbar && <div>{toolbar}</div>}
        </DialogHeader>
        <div className="min-h-0 overflow-y-auto">{children}</div>
      </DialogContent>
    </Dialog>
  )
}
